module.exports = __webpack_public_path__ + "img/hotel.86ffdd95.jpg";